export default "__VITE_ASSET__IWoBi8Fi__"